import { useCallback } from "react";

import { useStreamingAvatarStore } from "@/features/avatar/lib/useStreamingAvatarStore";

export const useInterrupt = () => {
    const { avatar } = useStreamingAvatarStore();

    const interrupt = useCallback(() => {
        if (!avatar) return;
        avatar.interrupt();
    }, [avatar]);

    return { interrupt };
};
